<template>
    <div id="list-item" @click="openDetail">

        <div style="padding-right: 8px;">
            <span class="item-title">
                {{ title }}
            </span>

            <span class="apply-company-title">
                {{location}}
            </span>
        </div>

        <div style="font-size: 13px; margin-top: 2px;">
            {{ apply_company }}
        </div>

        <div style="margin-right: 8px; margin-top: 10px;">
            <divider></divider>
        </div>

        <div class="summary">
            <div class="oval"></div>
            {{ summary_condition }}
        </div>

        <div class="summary" style="margin-top: 12px">
            <div class="oval"></div>
            {{ summary_benefit }}
        </div>

        <div style="margin-top: 20px;">
            <el-tag class="tag-item"
                    v-for="(item, idx) in tags"
                    :key="idx"
                    effect="dark">
                {{ item }}
            </el-tag>
        </div>
    </div>
</template>

<script>
    import Divider from "@/components/common/divider";

    export default {
        name: "list_item",
        components: {Divider},
        props: {
            lidx: Number,
            idx: Number,
            title: String,
            is_corona: Number,
            income_type: Number,
            income: String,
            childbirth_type: Number,
            child_birth: String,
            apply_online: Number,
            require_card: Number,
            multi_cultural: Number,
            disabled: Number,
            second_tier: Number,
            basic_income: Number,
            one_parent: Number,
            detail_condition: String,
            detail_required_document: String,
            detail_benefit: String,
            detail_how_apply: String,
            detail_etc: String,
            summary_condition: String,
            summary_benefit: String,
            locations: Array,
            apply_company: String
        },
        data() {
            return {
                tags: [],
                location: ""
            }
        },
        beforeMount() {
            this.initLayout();
        },
        methods: {
            initLayout() {

                if (this.is_corona == 1) {
                    this.tags.push(`코로나 지원`)
                }

                if (this.child_birth != 0) {

                    var birth = null;
                    let months = parseInt(this.child_birth);

                    if (months > 12) {
                        let year = parseInt(months / 12);
                        let new_month = months - (year * 12);

                        if (new_month != 0) {
                            birth = `${year}년 ${new_month}개월`;
                        } else {
                            birth = `${year}년`;
                        }
                    } else {
                        birth = `${months}개월`;
                    }


                    if (this.childbirth_type == 0) {
                        this.tags.push(`임신 후 ${birth} 이내`)
                    } else {
                        this.tags.push(`출산 후 ${birth} 이내`)
                    }
                }

                if (this.income != 0) {
                    if (this.income_type == 0) {
                        this.tags.push(`월 수입 ${parseInt(this.income).toLocaleString()}원 이하`)
                    } else {
                        this.tags.push(`건강보험료 ${parseInt(this.income).toLocaleString()}원 이하`)
                    }
                }

                if (this.apply_online == 0) {
                    this.tags.push(`현장 신청가능`)
                } else if (this.apply_online == 1) {
                    this.tags.push(`온라인 신청가능`)
                } else {
                    this.tags.push(`온라인/현장 신청가능`)
                }

                if (this.require_card == 1) {
                    this.tags.push(`지원카드 필요`)
                }

                if (this.multi_cultural == 1) {
                    this.tags.push(`다문화 자녀`)
                }

                if (this.disabled == 1) {
                    this.tags.push(`장애여부`)
                }

                if (this.second_tier == 1) {
                    this.tags.push(`차상위 계층`)
                }

                if (this.basic_income == 1) {
                    this.tags.push(`기초수급`)
                }

                if (this.one_parent == 1) {
                    this.tags.push(`한부모 가정`)
                }

                if (this.locations != undefined) {

                    if (this.lidx != undefined) {

                        if (this.lidx != 1) {
                            let currentLocation = this.findLocation(this.lidx, false);
                            let parentLocation = this.findLocation(currentLocation.value, true);

                            if (parentLocation.value == 1) {
                                this.location = currentLocation.label;
                            } else {
                                this.location = parentLocation.label + "/" + currentLocation.label;
                            }

                        } else if (this.lidx == 1) {
                            this.location = "정부";
                        }
                    }
                }
            },
            findLocation(lidx, isParent) {
                for (let i = 0; i < this.locations.length; i++) {

                    for (let j = 0; j < this.locations[i].children.length; j++) {
                        if (this.locations[i].children[j].value == lidx) {
                            if (isParent) {
                                return this.locations[i];
                            } else {
                                return this.locations[i].children[j];
                            }

                        }
                    }
                }
            },
            openDetail() {
                let route = this.$router;
                route.push({name: 'detail', params: {sidx: this.idx}});
            }
        }
    }
</script>

<style scoped>

    * {
        color: #3d3d3d;
    }

    #list-item {
        text-align: left;
        margin-top: 12px;
        padding: 20px 8px 20px 20px;
        background-color: white;
        border: 1px solid #eeeeee;
        cursor: pointer;
    }

    .tag-item {
        margin-right: 8px;
        margin-bottom: 6px;
        color: #3d3d3d;
        background-color: #ffea6d;
        border-color: #ffea6d;
        border-radius: 20px;
        font-weight: 600;
    }

    .item-title {
        font-weight: bold;

    }

    .apply-company-title {
        position: relative;
        float: right;
        font-size: 13px;
        font-weight: 400;
    }

    .summary {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: 14px;
        font-weight: 400;
    }

    .oval {
        width: 6px;
        height: 6px;
        background-color: black;
        border-radius: 50%;
        float: left;
        margin-top: 4px;
        margin-right: 6px;
    }

</style>